import axios from "axios";
import { apiUrl, baseUrl } from "./constant";


// Apply Teacher
export async function contactUs(data) {
    console.log(data);
    if ((data)) {
        const resp = await axios({
            method: 'post',
            url: apiUrl + "contactus",
            headers: {
                Accept: 'application/json',
            },
            data: data,
        });
        return resp;
    } else {
        console.log("Please add required parameters");
    }
}

export async function bookings(data) {
    if ((data)) {
        const resp = await axios({
            method: 'post',
            url: apiUrl + "bookings/",
            headers: {
                Accept: 'application/json',
            },
            data: data,
        });
        return resp;
    } else {
        console.log("Please add required parameters");
    }
}

export async function careers(data) {
    if ((data)) {
        const resp = await axios({
            method: 'post',
            url: apiUrl + "careers/",
            headers: {
                Accept: 'application/json',
            },
            data: data,
        });
        return resp;
    } else {
        console.log("Please add required parameters");
    }
}